import styled from "styled-components";

export const ImgBoxWrap = styled.div`
  overflow: hidden;
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
  /* background: var(--Fill_Brand_Primary); */
  position: relative;
  flex: 1;
  width: 100%;
  img {
    /* width: auto;
    height: auto; */
    cursor: grab;
    display: inline-block;
    pointer-events: none;
  }
  .img-hide {
    display: none;
  }
  .img-visibility {
    visibility: hidden;
  }
  .no-ppt {
    font-weight: 400;
    font-size: 14px;
    color: var(--Text_Disabled);
    letter-spacing: 0;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    img {
      height: 120px;
      width: 114px;
      margin-bottom: 12px;
    }
  }
  .operation-panel {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    color: var(--Text_White);
    height: 40px;
    /* width: 143px; */
    padding: 10px 12px;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 8px;
    &:hover {
      .show-tips {
        .percent {
          display: block;
        }
      }
    }
    .opear-icon {
      display: inline-block;
      /* width: 16px;
      height: 16px; */
      line-height: 12px;
      text-align: center;
      color: var(--Text_White);
      cursor: pointer;
      .tingwu-icon {
        pointer-events: none;
      }
      &:hover {
        color: var(--Text_White);
      }
    }
    .reset {
      margin-left: 12px;
      position: relative;
      display: flex;
      &:hover {
        .show-tip {
          display: block;
        }
      }
    }
    .show-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      .percent {
        display: none;
        position: absolute;
        top: -8px;
        font-size: 10px;
        color: var(--Fill_Disabled);
        transform: scale(0.8);
        text-align: center;
        user-select: none;
      }
      .tips-line {
        height: 2px;
        background-color: var(--Fill_Disabled);
        border-radius: 3px;
        width: 70px;
        margin: 0 8px;
        position: relative;
        .circleSlide {
          cursor: pointer;
          position: absolute;
          top: -5px;
          width: 12px;
          height: 12px;
          background-color: var(--Text_Brand_Primary);
          border-radius: 50%;
          &:hover {
            background-color: var(--Fill_Background);
          }
        }
      }
    }
  }
`;

export const Message: any = styled.div`
  display: none;
  position: absolute;
  height: 40px;
  width: max-content;
  background: #333;
  bottom: 44px;
  border-radius: 8px;
  .arrow {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    span {
      user-select: none;
      color: #fff;
      text-align: start;
      text-decoration: none;
      word-wrap: break-word;
    }
    &::before {
      content: "";
      z-index: 1;
      display: block;
      pointer-events: none;
      width: 16px;
      height: 16px;
      overflow: hidden;
      position: absolute;
      bottom: -8px;
      background: #333;
      transform: rotate(45deg);
    }
  }
`;
